export default `.ids-month-view {
  display: flex;
  background-color: var(--ids-calendar-month-view-color-background-default);
  width: 100%;
  box-sizing: border-box;
  flex-direction: column;
  overflow: auto;
  max-width: inherit;
}
.ids-month-view .month-view-container {
  background-color: var(--ids-calendar-month-view-color-background-default);
  flex-shrink: 0;
}
.ids-month-view .month-view-table-header th {
  background-clip: padding-box;
  height: 30px;
  line-height: 30px;
  text-align: center;
  width: 14.3%;
}
.ids-month-view .month-view-table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
}
.ids-month-view .trigger-icon {
  color: var(--ids-color-blue-60);
}
.ids-month-view .month-view-legend {
  margin: 0 auto;
  padding: 10px 5px 0;
}
.ids-month-view .month-view-legend-swatch,
.ids-month-view .month-view-legend-item,
.ids-month-view .month-view-legend-text {
  display: inline-block;
}
.ids-month-view .month-view-legend-item {
  margin-bottom: 2px;
}
.ids-month-view .month-view-legend-swatch {
  background-color: var(--legend-color);
  opacity: 0.3;
  width: 16px;
  height: 16px;
}
.ids-month-view .month-view-legend-item.event-type .month-view-legend-swatch {
  border-radius: 10px;
  opacity: 1;
  width: 14px;
  height: 14px;
}
.ids-month-view .month-view-legend-text {
  position: relative;
  color: var(--ids-calendar-month-view-legend-color-text);
  padding: 0 10px 0 8px;
  top: -2px;
}
.ids-month-view .events-container {
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
}
.ids-month-view .events-container .events-overflow {
  position: absolute;
  bottom: 0;
  cursor: pointer;
  text-indent: 12px;
}
.ids-month-view .events-container ids-text::part(text) {
  text-transform: capitalize;
}

.ids-month-view.is-compact {
  position: relative;
}
.ids-month-view.is-compact .month-view-table-header th {
  line-height: unset;
  vertical-align: top;
  height: 22px;
}
.ids-month-view.is-compact .month-view-table {
  margin-top: 13px;
}
.ids-month-view.is-compact .weekday-text {
  color: var(--ids-calendar-month-view-weekday-color-text-compact);
}
.ids-month-view.is-compact td {
  width: 44px;
  height: 44px;
  text-align: center;
}
.ids-month-view.is-compact td:not(.is-disabled):hover {
  cursor: pointer;
}
.ids-month-view.is-compact td.week-num-cell:hover {
  cursor: default;
}
.ids-month-view.is-compact td .day-container {
  display: inline-block;
  position: relative;
  border-radius: 50%;
  border: 1px solid transparent;
  margin: 5px 0;
}
.ids-month-view.is-compact td .day-text {
  display: inline-block;
  position: relative;
  z-index: 2;
  border-radius: 50%;
  margin: 2px;
  color: var(--ids-calendar-month-view-color-text-default);
  white-space: nowrap;
  transition: 0.2s background-color ease;
}
.ids-month-view.is-compact td.alternate .day-text {
  color: var(--ids-calendar-month-view-color-text-compact);
}
.ids-month-view.is-compact td.is-disabled .day-text {
  background-color: var(--ids-color-neutral-10);
  color: var(--ids-color-neutral-30);
}
.ids-month-view.is-compact td.is-disabled.has-legend .day-container::after {
  opacity: 0.4;
}
.ids-month-view.is-compact td.is-disabled.has-legend .day-text {
  background-color: transparent;
}
.ids-month-view.is-compact td ids-text::part(text) {
  border-radius: 50%;
  box-sizing: border-box;
  width: 35px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  display: inline-block;
}
.ids-month-view.is-compact td:hover .day-text {
  color: var(--ids-calendar-month-view-weekday-color-text-compact-hover);
}
.ids-month-view.is-compact td.ids-disabled:hover .day-text {
  color: var(--ids-color-gray-30);
}
.ids-month-view.is-compact td.is-selected .day-text {
  color: var(--ids-calendar-month-view-weekday-color-text-compact-selected-hover);
  background-color: var(--ids-calendar-month-view-day-color-background-compact-selected);
}
.ids-month-view.is-compact td.is-selected:focus {
  outline: none;
  outline-style: none;
}
.ids-month-view.is-compact td.is-selected:not(.is-disabled):not(.range-selection):focus ids-text::part(text) {
  width: 31px;
  height: 31px;
  line-height: 31px;
}
.ids-month-view.is-compact td.is-selected:not(.is-disabled):not(.range-selection):focus ids-text {
  margin: 2px;
}
.ids-month-view.is-compact td.is-selected:not(.is-disabled):not(.range-selection):focus .day-container {
  border-color: var(--ids-calendar-month-view-day-color-background-compact-selected);
  z-index: 2;
  box-shadow: 0 0 2px 0 var(--ids-calendar-month-view-day-color-background-compact-selected);
}
.ids-month-view.is-compact td.is-today:not(.is-selected) .day-text::part(text) {
  border: 1px solid var(--ids-calendar-month-view-today-color-border-compact);
}
.ids-month-view.is-compact td:not(.is-disabled):not(.is-selected):not(.has-legend):not(.range-selection):hover .day-text, .ids-month-view.is-compact td:not(.is-disabled):not(.is-selected):not(.has-legend):not(.range-selection):active .day-text {
  background-color: var(--ids-calendar-month-view-day-color-background-compact-hover);
}
.ids-month-view.is-compact td.has-legend:not(.is-disabled):hover .day-container::after {
  opacity: 0.7;
}
.ids-month-view.is-compact td.has-legend .day-container::after {
  border-radius: 50%;
  position: absolute;
  content: "";
  background-color: var(--legend-color);
  display: inline-block;
  width: 35px;
  height: 35px;
  overflow: hidden;
  opacity: 0.3;
  transition: 0.2s opacity ease;
  inset: 0;
  margin: auto;
}
.ids-month-view.is-compact td.range-selection + .range-selection, .ids-month-view.is-compact td.range-next:not(:first-of-type), .ids-month-view.is-compact td.range-prev:not(:last-of-type) {
  position: relative;
}
.ids-month-view.is-compact td.range-selection + .range-selection::before, .ids-month-view.is-compact td.range-next:not(:first-of-type)::before, .ids-month-view.is-compact td.range-prev:not(:last-of-type)::before {
  position: absolute;
  width: 100%;
  z-index: 1;
  content: "";
  display: inline-block;
  height: 35px;
  top: 0;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
}
.ids-month-view.is-compact td.is-disabled.range-selection.not-included + .range-selection::before, .ids-month-view.is-compact td.is-disabled.range-prev.not-included::before {
  content: none;
}
.ids-month-view.is-compact td:not(.is-disabled.not-included).range-prev .day-text, .ids-month-view.is-compact td:not(.is-disabled.not-included).range-next .day-text, .ids-month-view.is-compact td:not(.is-disabled.not-included).range-next:not(:first-of-type)::before, .ids-month-view.is-compact td.range-prev:not(:last-of-type)::before {
  background-color: var(--ids-calendar-month-view-range-color-background-compact);
}
.ids-month-view.is-compact td.range-selection:not(:first-of-type)::before, .ids-month-view.is-compact td:not(.is-disabled.not-included).range-selection .day-text {
  background-color: var(--ids-calendar-month-view-range-color-background-compact-selected);
}
.ids-month-view.is-compact td.range-selection:not(.alternate):not(.is-disabled.not-included) .day-text {
  color: var(--ids-calendar-month-view-range-color-text-compact-selected);
}
.ids-month-view.is-compact td.range-selection:not(:first-of-type)::before, .ids-month-view.is-compact td.range-next:not(:first-of-type)::before {
  inset-inline-end: 50%;
}
.ids-month-view.is-compact td.range-prev:not(:last-of-type)::before {
  inset-inline-end: -50%;
}
.ids-month-view.is-compact td.range-selection .day-text, .ids-month-view.is-compact td.range-prev .day-text, .ids-month-view.is-compact td.range-next .day-text {
  border-radius: 50%;
  z-index: 2;
  transition: none;
}
.ids-month-view.is-compact th,
.ids-month-view.is-compact td {
  padding: 0;
}
.ids-month-view.is-compact.range-select-week td .day-text {
  transition: none;
}
.ids-month-view.is-compact .btn-today {
  margin-right: -7px;
}
.ids-month-view.is-compact .btn-today::part(button) {
  padding-inline: 4px;
  padding-block: 2px;
  margin: 3px;
}
.ids-month-view.is-compact .btn-previous,
.ids-month-view.is-compact .btn-next {
  padding-inline-start: 0;
  margin: 3px;
}
.ids-month-view.is-compact .btn-previous::part(button),
.ids-month-view.is-compact .btn-next::part(button) {
  padding: 0;
  width: 38px;
  height: 38px;
}
.ids-month-view.is-compact .month-view-legend {
  padding-top: 27px;
  max-width: 300px;
}
.ids-month-view.is-compact .week-num-cell {
  border-inline-end: 1px solid var(--ids-calendar-month-view-color-border);
}
.ids-month-view.is-compact .week-num-cell ids-text {
  color: var(--ids-month-view-week-number-text-color);
  cursor: default;
}

.ids-month-view.is-fullsize {
  border-style: solid;
  border-width: 1px 1px 0;
  border-color: var(--ids-calendar-month-view-color-border);
}
.ids-month-view.is-fullsize .weekday-text {
  color: var(--ids-calendar-month-view-weekday-color-text);
}
.ids-month-view.is-fullsize.is-disabled.has-legend {
  opacity: 0.4;
  background-color: transparent;
}
.ids-month-view.is-fullsize .day-text {
  color: var(--ids-calendar-month-view-color-text-default);
}
.ids-month-view.is-fullsize td {
  border-style: solid;
  border-width: 0 1px 1px;
  position: relative;
  transition: 0.1s background-color ease-out;
}
.ids-month-view.is-fullsize td:last-child {
  border-right: 0;
}
.ids-month-view.is-fullsize td:first-child {
  border-left: 0;
}
.ids-month-view.is-fullsize td {
  height: 140px;
  width: 14.3%;
  overflow: hidden;
  user-select: none;
}
.ids-month-view.is-fullsize td:not(.is-selected):not(.has-legend):not(.is-disabled):hover, .ids-month-view.is-fullsize td:not(.is-selected):not(.has-legend):not(.is-disabled):active {
  background-color: var(--ids-calendar-month-view-color-background-hover);
}
.ids-month-view.is-fullsize td.is-disabled {
  opacity: 0.5;
  background-color: var(--ids-calendar-month-view-color-background-disabled);
}
.ids-month-view.is-fullsize td.is-disabled.has-legend::after {
  opacity: 0.4;
}
.ids-month-view.is-fullsize td.is-selected:not(.has-legend) {
  background-color: var(--ids-calendar-month-view-color-background-selected);
}
.ids-month-view.is-fullsize td.is-selected {
  box-shadow: inset 0 5px 0 0 var(--ids-calendar-month-view-color-selected);
}
.ids-month-view.is-fullsize td.is-selected:focus {
  outline: none;
}
.ids-month-view.is-fullsize td.has-legend::after {
  position: absolute;
  width: 100%;
  background-color: var(--legend-color);
  content: "";
  inset: 0;
  opacity: 0.3;
}
.ids-month-view.is-fullsize td.has-legend.is-selected::after {
  top: 5px;
}
.ids-month-view.is-fullsize td.has-legend:hover::after {
  opacity: 0.7;
}
.ids-month-view.is-fullsize td.alternate .day-text {
  color: var(--ids-calendar-month-view-color-text-alternate);
}
.ids-month-view.is-fullsize td .day-text {
  position: absolute;
  cursor: pointer;
  z-index: 1;
  left: calc(100% - 25px);
  top: var(--ids-month-view-day-text-top, 13px);
  width: 10px;
  text-align: center;
}
.ids-month-view.is-fullsize td.month-label .day-text {
  left: auto;
  width: 100%;
  text-align: right;
}
.ids-month-view.is-fullsize td.month-label ids-text::part(text) {
  font-weight: 600;
  padding-right: 10px;
}
.ids-month-view.is-fullsize th,
.ids-month-view.is-fullsize td {
  padding: 0;
  border-bottom: 1px solid;
  border-color: var(--ids-calendar-month-view-color-border);
}
.ids-month-view.is-fullsize.has-legend .month-view-container {
  border-bottom: 1px solid var(--ids-calendar-month-view-color-border);
}

.ids-month-view.is-date-picker {
  overflow: visible;
}
.ids-month-view.is-date-picker .month-view-container {
  padding-left: 10px;
  padding-right: 10px;
}
.ids-month-view.is-date-picker td .day-container {
  margin: 0;
}
.ids-month-view.is-date-picker ids-date-picker {
  margin-left: 12px;
}

.ids-month-view.is-date-picker .month-view-legend,
.ids-month-view.is-fullsize .month-view-legend {
  text-align: center;
}

.month-view-legend-item.event-type .month-view-legend-swatch {
  border-radius: 10px;
  opacity: 1;
}

ids-toolbar ids-menu-button[menu=view-picker] {
  margin-inline-end: 8px;
}

.monthview-toolbar-pane {
  display: flex;
  border-width: 1px 1px 0;
  border-style: solid;
  background-color: var(--ids-calendar-toolbar-color-background);
  border-color: var(--ids-calendar-toolbar-color-border);
}
.monthview-toolbar-pane .monthview-toolbar {
  padding: var(--ids-space-xs);
}
.monthview-toolbar-pane .btn-previous,
.monthview-toolbar-pane .btn-next {
  height: 36px;
}
.monthview-toolbar-pane .btn-picker {
  display: inline-flex;
  vertical-align: middle;
  margin-inline: 2px;
}
.monthview-toolbar-pane .btn-today {
  margin-inline-start: 2px;
}
.monthview-toolbar-pane .btn-today-text {
  color: var(--ids-color-accent-blue-strong);
}

:host([dir=rtl]) .ids-month-view.is-fullsize td .day-text {
  left: unset;
  right: calc(100% - 25px);
}
:host([dir=rtl]) .ids-month-view.is-fullsize td.month-label .day-text {
  right: auto;
  text-align: left;
}
:host([dir=rtl]) .ids-month-view.is-fullsize td.month-label ids-text::part(text) {
  padding-right: unset;
  padding-left: 10px;
}
:host([dir=rtl]) .ids-month-view.is-fullsize td:last-child {
  border-left: 0;
}
:host([dir=rtl]) .ids-month-view.is-date-picker ids-date-picker {
  margin-left: 0;
  margin-right: 12px;
}
:host([dir=rtl]) .ids-month-view.is-date-picker .btn-today {
  margin-right: 0;
  margin-left: -7px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
